// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"206":"f85da9ae","296":"f85da9ae","331":"f85da9ae"}[chunkId] + ".chunk.css";
};